module.exports = __webpack_public_path__ + "img/youtube.91a3b00e.png";